<template>
  <div>
    <div>
      <account-selector v-if="organizationID === null || organization === null" v-on:selectedAccount="(e) => { selectedAccount(e) }" style="color: #000;"></account-selector>
    </div>
    <div class="d-flex" v-if="organizationID !== null && organization !== null">
      <b-form-input v-model="organization.organization_name" :disabled="true" placeholder="Enter your name"></b-form-input>
      <a class="btn btn-sm" @click="clearAccount">
        <i class="fas fa-times" v-b-tooltip.hover title="Clear organization"></i>
      </a>
    </div>
  </div>
</template>

<script>
import AccountSelector from './AccountSelector'
import API from '../../api/index'
export default {
  name: '',
  components: {AccountSelector},
  props: ['organizationID'],
  data: function () {
    return {
      organization: null
    }
  },
  methods: {
    selectedAccount (e) {
      this.organization = e
      this.$emit('selectedOrganization', e)
      console.log(e)
    },
    clearAccount () {
      this.organization = null
      this.$emit('selectedOrganization', null)
    },
    setAccount () {
      API.getAutocompleteAccountV2({'account_ids': this.organizationID}).then(
        response => {
          let accounts = response.data
          if (accounts.length === 1) {
            this.organization = accounts[0]
          }
        }
      )
    }
  },
  mounted () {
    this.setAccount()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tools/OrganizationSelectorV2.vue